import { render, staticRenderFns } from "./KolEdit.vue?vue&type=template&id=5107a8ae&"
import script from "./KolEdit.vue?vue&type=script&lang=js&"
export * from "./KolEdit.vue?vue&type=script&lang=js&"
import style0 from "./KolEdit.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports